import type { DocumentListRow } from "~/features/orders/orderList/useOrderListState";
import type { OrderAccountData, OrderData } from "~/domains/orders/types/modelsV2";
import type { QuoteDetailsEntryStatus } from "~/domains/orders/types/GetItemStatus";

export const isErrorEntry = (row: DocumentListRow<OrderData>) => {
  return row.data.soNumber === "-";
};

export const addStatusHover = (status: string) => {
  return status === "PR";
};

export const isFromDifferentAccOrSalesOrg = (row: DocumentListRow<{ account?: OrderAccountData }>) => {
  return (
    (row.data.account?.code && row.data.account?.code !== window.SCHA.user.selectedAccount.uid) ||
    (row.data.account?.salesOrg && row.data.account?.salesOrg !== window.SCHA.user.selectedAccount.salesOrg)
  );
};

export const getQuoteStatus = (status: string) => {
  if (status === "codes.quoteStatus.Q1") {
    return "success";
  }
  if (status === "codes.quoteStatus.Q5") {
    return "warn";
  }
  return "default";
};

export const getQuoteLineStatus = (status: QuoteDetailsEntryStatus) => {
  if (status === "OV10") {
    return "success";
  }
  return "default";
};
